<template>
  <div>
    <!-- 新增按钮 -->

    <DatePicker
      v-model="searchDate"
      type="daterange"
      placement="bottom-end"
      placeholder="选择时间"
      style="width: 200px"
      :options="options3"
    ></DatePicker>
    <Button type="primary" @click="resetFormData">清除</Button>

    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <!-- <Page
          :total="total"
          :current="current"
          :page-size="50"
          @on-change="changePage"
        ></Page> -->
      </div>
    </div>
    <Modal v-model="modal1" title="充值详情" width="500">
      <div>
        <Table :columns="columns" :data="data"> </Table>
      </div>

      <div slot="footer">
        <Button @click="cancelFenghao">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { t } from "iview";
import { queryPackageOrders, seldateuser } from "../../api/user";

export default {
  components: {},
  data() {
    return {
      selUser: {},
      reasontxt: "",
      amount: 0, // 输入的金额或者能量
      isfengjin: false,
      modal1: false,
      searchDate: [],
      loading: false,
      beizhu: "",
      clickuserid: "",
      lianxu: "",
      data: [],
      columns: [
        {
          title: "充值时间",
          key: "createtimes",
        },
        {
          title: "充值金额",
          key: "paymoney",
        },
        {
          title: "用户id",
          key: "user_id",
        },
        {
          title: "充值方式",
          key: "npaytype",
          render: (h, params) => {
            const type = params.row.npaytype;
            return h("span", (type == 1 || type == 3) ? "支付宝" : type == 2 ? "苹果" : type == 5 ? "云闪付" : "微信");
          },
        },
        {
          title: "用户昵称",
          key: "user_nickname",
        },
      ],
      data9: [], // 用于存储查询结果
      columns10: [
        {
          title: "日期",
          key: "time",
        },
        {
          title: "充值总额",
          key: "totalPaymoney",
        }
      ],
      current: 1,
      total: 0,
      options3: {
        disabledDate(date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 将时间设置为当天的开始
          return date && date.getTime() > today.getTime() - 1;
        },
      },
    };
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    shenhe(row, columns) {
      console.log(row);
      console.log(row[columns]);
      seldateuser({ times: row.time, rname: columns }).then((res) => {
        this.data = res.data;
        this.modal1 = true;
      });
    },
    close() {
      this.visible = false;
    },
    // disabledDate(date) {
    //   // 禁止选择今天及以后的日期

    // },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      queryPackageOrders(params)
        .then((response) => {
          this.data9 = response.data; // 获取查询结果
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // 查询商品
    queryGoods() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        startDate:starttime,
        endDate:endtime,
        page: this.current,
      };
      this.fetchGoodsData(params);
    },
    // 格式化函数，将 Date 对象转换为 YYYY-MM-DD HH:mm:ss 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },
    cancelFenghao() {
      this.modal1 = false;
    },
    resetFormData() {
      // 重置表单数据
      this.searchId = "";
      this.searchName = "";
      this.searchPhone = "";
      this.searchDate = [];
      this.current = 1;
      this.queryGoods();
    },
  },
  watch: {
    data9: {
      handler(newData) {
        if (!newData || newData.length === 0) return;
        
        this.columns10 = [
          {
            title: "日期",
            key: "time",
          },
          {
            title: "充值总额",
            key: "totalPaymoney",
          },
          ...Object.keys(newData[0]).filter(key =>
            !["time", "totalPaymoney"].includes(key) &&
            newData.some(item => Number(item[key]) > 0)
          ).map(key => ({
            title: `套餐${key}`,
            key: key,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small",
                      disabled: params.row[key] == 0,
                    },
                    on: {
                      click: () => {
                        this.shenhe(params.row, key);
                      },
                    },
                  },
                  params.row[key] + "笔"
                ),
              ]);
            },
          }))
        ];
      },
      immediate: true
    }
  }
};
</script>
